import React from 'react';
import EmbeddedNotepadClusterNotesTab from 'shared_items/embeddedNotepad/EmbeddedNotepadClusterNotesTab';
import {
  getHealthEmbeddedNotepadCluster,
  patchHealthEmbeddedNotepadCluster,
} from '../health_services';

const MainHealthNotes = () => (
  <EmbeddedNotepadClusterNotesTab
    layoutVariant="module-tab"
    containerClassName=""
    fabClassName="bg-blue-500 hover:bg-blue-600"
    fetchClusterLink={async () => {
      const res = await getHealthEmbeddedNotepadCluster();
      return res.data;
    }}
    patchClusterLink={async (clusterId) => {
      const res = await patchHealthEmbeddedNotepadCluster(
        clusterId != null ? Number(clusterId) : null,
      );
      return res.data;
    }}
  />
);

export default MainHealthNotes;
